import { render, staticRenderFns } from "./FooldalMobileLayout.vue?vue&type=template&id=5162c2dc&"
import script from "./FooldalMobileLayout.vue?vue&type=script&lang=js&"
export * from "./FooldalMobileLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports